import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { 
  FaClock, FaCalendarAlt, FaUsers, FaStar, FaCheckCircle, FaArrowRight,
  FaBookOpen, FaCertificate,FaLaptop, FaTrophy, FaClipboardCheck, FaGraduationCap,
  FaRupeeSign, FaExternalLinkAlt, FaAward, FaListUl
} from 'react-icons/fa';

const PageContainer = styled.div`
  margin-top: 180px;
  background: #ffffff;

  @media (max-width: 1366px) and (min-width: 769px) {
    margin-top: 155px;
  }


  @media (max-width: 768px) {
    margin-top: 120px;
  }
`;

/* ========== HERO ========== */
const HeroSection = styled.div`
  background: linear-gradient(135deg, #1a1a2e 0%, #3730A3 50%, #0b0b77 100%);
  color: white;
  padding: 2.5rem 5%;
  text-align: center;
`;

const HeroBadge = styled.span`
  display: inline-flex; align-items: center; gap: 0.5rem;
  background: rgba(255,255,255,0.1); padding: 0.4rem 1.2rem; border-radius: 50px;
  font-size: 0.9rem; font-weight: 600; margin-bottom: 1rem;
  svg { color: #a78bfa; }
`;

const HeroTitle = styled.h1`
font-family: 'Times New Roman', serif;
  font-size: 2.8rem; font-weight: 800; margin-bottom: 0.5rem;
  span { display: block; color: #a78bfa; font-size: 1.2rem; font-weight: 400; margin-top: 0.2rem; }
  @media (max-width: 768px) { font-size: 2rem; span { font-size: 1rem; } }
`;

const HeroDesc = styled.p`
font-family: 'Times New Roman', serif;
  font-size: 1rem; opacity: 0.85; max-width: 600px; margin: 0.5rem auto 1rem;
`;

const HeroInfo = styled.div`
  display: flex; justify-content: center; gap: 1.5rem; flex-wrap: wrap; margin-top: 1rem;
  div { display: flex; align-items: center; gap: 0.4rem; background: rgba(255,255,255,0.08); padding: 0.5rem 1rem; border-radius: 30px; font-size: 0.9rem; 
    svg { color: #a78bfa; } strong { color: #a78bfa; } }
`;

/* ========== CONTAINER ========== */
const Container = styled.div`
  max-width: 1100px; margin: 0 auto; padding: 2.5rem 5% 3rem;
`;

/* ========== LAYOUT ========== */
const TwoCol = styled.div`
  display: grid; grid-template-columns: 1fr 1fr; gap: 1.5rem; margin-bottom: 1.5rem;
  @media (max-width: 800px) { grid-template-columns: 1fr; }
`;

/* ========== CARDS ========== */
const SectionCard = styled.div`
  background: white; border-radius: 14px; padding: 1.5rem;
  border: 1px solid #f0f0f5; box-shadow: 0 2px 10px rgba(0,0,0,0.02);
`;

const CardTitle = styled.h3`
font-family: 'Times New Roman', serif;
  font-size: 1.1rem; color: #1a1a2e; font-weight: 700; margin-bottom: 1rem;
  display: flex; align-items: center; gap: 0.6rem;
  .card-icon { width: 36px; height: 36px; border-radius: 10px; background: #f5f3ff; color: #3730A3; display: flex; align-items: center; justify-content: center; font-size: 1rem; }
`;

const SimpleList = styled.ul`
font-family: 'Times New Roman', serif;
  list-style: none; padding: 0;
  li { display: flex; align-items: flex-start; gap: 0.6rem; padding: 0.4rem 0; color: #4a4a6a; font-size: 0.9rem; line-height: 1.5;
    svg { color: #3730A3; font-size: 0.85rem; margin-top: 3px; flex-shrink: 0; } }
`;

const NumberedList = styled.div`
  display: flex; flex-direction: column; gap: 0.5rem;
`;

const NumberedItem = styled.div`
font-family: 'Times New Roman', serif;
  display: flex; align-items: flex-start; gap: 0.8rem;
  .num { width: 28px; height: 28px; border-radius: 50%; background: #3730A3; color: white; display: flex; align-items: center; justify-content: center; font-weight: 700; font-size: 0.8rem; flex-shrink: 0; }
  p { color: #4a4a6a; font-size: 0.9rem; line-height: 1.5; }
`;

const HighlightBox = styled.div`
font-family: 'Times New Roman', serif;
  background: #f5f3ff; border-radius: 12px; padding: 1.2rem 1.5rem; margin-bottom: 1.5rem;
  border-left: 4px solid #3730A3;
`;

const PracticeGrid = styled.div`
  display: grid; grid-template-columns: repeat(3, 1fr); gap: 1rem; margin-bottom: 1.5rem;
  @media (max-width: 600px) { grid-template-columns: 1fr; }
`;

const PracticeCard = styled.div`
font-family: 'Times New Roman', serif;
  background: white; border-radius: 12px; padding: 1.2rem; text-align: center;
  border: 1px solid #f0f0f5;
  .practice-icon { font-size: 1.5rem; color: #3730A3; margin-bottom: 0.5rem; }
  h4 { font-size: 0.95rem; color: #1a1a2e; margin-bottom: 0.3rem; }
  p { font-size: 0.85rem; color: #4a4a6a; }
`;

/* ========== CURRICULUM ========== */
const CurrList = styled.div`
  display: flex; flex-direction: column; gap: 0.5rem; margin-bottom: 1.5rem;
`;

const CurrItem = styled.div`
font-family: 'Times New Roman', serif;
  display: flex; align-items: center; gap: 0.8rem; padding: 0.8rem 1rem;
  background: #fafbff; border-radius: 10px; border: 1px solid #f0f0f5;
  svg { color: #3730A3; font-size: 0.9rem; }
  span { color: #1a1a2e; font-size: 0.9rem; font-weight: 500; }
`;

/* ========== CERT BLOCK ========== */
const CertBlock = styled.div`
  background: #fff;
  border: 1px solid #f0f0f5;
  border-radius: 14px;
  overflow: hidden;
  margin-bottom: 1.5rem;
`;

const CertHead = styled.div`
  background: #3730A3;
  padding: 1.2rem 1.8rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.8rem;
`;

const CertHeadTitle = styled.div`
  font-family: 'Times New Roman', serif;
  font-size: 1.1rem;
  color: #fff;
  font-weight: 800;
`;

const CertHeadBadge = styled.div`
  font-family: 'Times New Roman', serif;
  background: rgba(167, 139, 250, 0.2);
  color: #a78bfa;
  border: 1px solid rgba(167, 139, 250, 0.3);
  font-size: 0.72rem;
  letter-spacing: 1px;
  text-transform: uppercase;
  padding: 0.3rem 0.8rem;
  border-radius: 4px;
  font-weight: 700;
`;

const CertBody = styled.div`
  padding: 1.8rem;
`;

const CertDesc = styled.p`
  font-family: 'Times New Roman', serif;
  font-size: 0.95rem;
  color: #4a4a6a;
  line-height: 1.8;
  margin-bottom: 1.8rem;
  border-left: 3px solid #a78bfa;
  padding-left: 1.2rem;
`;

const CertCols = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1.5rem;
  margin-bottom: 1.8rem;

  @media (max-width: 650px) { grid-template-columns: 1fr; }
`;

const CertColTitle = styled.div`
  font-family: 'Times New Roman', serif;
  font-size: 0.78rem;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  color: #3730A3;
  font-weight: 700;
  margin-bottom: 0.8rem;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const PlainList = styled.ul`
  list-style: none;
  padding: 0;

  li {
    font-family: 'Times New Roman', serif;
    font-size: 0.92rem;
    color: #4a4a6a;
    padding: 0.35rem 0;
    border-bottom: 1px solid #f0f0f5;
    display: flex;
    align-items: flex-start;
    gap: 0.6rem;
    line-height: 1.5;

    &:last-child { border-bottom: none; }

    svg { color: #3730A3; font-size: 0.8rem; margin-top: 3px; flex-shrink: 0; }
  }
`;

const FeeTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-family: 'Times New Roman', serif;
  margin-bottom: 1rem;

  th {
    background: #1a1a2e;
    color: rgba(255,255,255,0.7);
    font-size: 0.75rem;
    letter-spacing: 1px;
    text-transform: uppercase;
    padding: 0.7rem 1.2rem;
    text-align: left;
    font-weight: 700;
  }

  td {
    padding: 0.9rem 1.2rem;
    border-bottom: 1px solid #f0f0f5;
    font-size: 0.95rem;
    color: #4a4a6a;
  }

  tr:last-child td { border-bottom: none; }

  .amt {
    font-size: 1.5rem;
    font-weight: 900;
    color: #1a1a2e;
  }

  tr.highlight { background: #f5f3ff; }
  tr.highlight .amt { color: #3730A3; }
  tr.highlight td { border-bottom: none; }
`;

const FeeNoteTag = styled.span`
  display: inline-block;
  font-size: 0.7rem;
  background: rgba(55,48,163,0.1);
  color: #3730A3;
  padding: 0.2rem 0.6rem;
  border-radius: 4px;
  margin-left: 0.5rem;
  vertical-align: middle;
  font-weight: 700;
`;

/* ========== CTA ========== */
const CTASection = styled.div`
  margin: 2rem 0 1rem;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  background: #1a1a2e;
  border-radius: 14px;
  overflow: hidden;
  padding: 1.5rem 1.5rem 1.5rem 0;

  &::before {
    content: '';
    width: 5px;
    align-self: stretch;
    background: #a78bfa;
    flex-shrink: 0;
  }

  @media (max-width: 650px) {
    flex-direction: column;
    padding: 1.5rem;
    &::before { display: none; }
  }
`;

const CTAText = styled.div`
  flex: 1;
  .cta-title {
    font-family: 'Times New Roman', serif;
    font-size: 1.4rem;
    font-weight: 800;
    color: #fff;
    margin-bottom: 0.3rem;
  }
  .cta-sub {
    font-family: 'Times New Roman', serif;
    font-size: 0.95rem;
    color: rgba(255,255,255,0.55);
    font-style: italic;
  }
`;

const CTAButton = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #a78bfa;
  color: #1a1a2e;
  font-family: 'Times New Roman', serif;
  font-weight: 700;
  font-size: 0.95rem;
  padding: 0.8rem 1.8rem;
  border-radius: 50px;
  text-decoration: none;
  white-space: nowrap;
  transition: all 0.3s ease;
  flex-shrink: 0;

  &:hover { 
    background: #c4b5fd; 
    transform: translateY(-2px);
  }
`;

const Spacer = styled.div`
  height: 2rem;
`;

const BasicCoding = () => {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  const topics = [
    "Overview of U.S. Healthcare",
    "Overview of Reimbursement Methodologies",
    "Basics of ICD-10-CM Coding",
    "Basics of CPT Coding",
    "Basics of HCPCS Coding"
  ];

  const practice = [
    { icon: <FaClipboardCheck />, title: "Exam Practice", desc: "4 Mock Papers" },
    { icon: <FaLaptop />, title: "Section Wise Practice", desc: "15 to 20 Hours" },
    { icon: <FaStar />, title: "Review & Feedback", desc: "6 to 8 Hours" }
  ];

  const benefits = [
    "Long-term stable career with plenty of opportunities to work anywhere in India",
    "Basic knowledge of physician based coding and outpatient coding settings",
    "Track record of passing rate of more than 98% apart from Trainee satisfaction",
    "Placement assistance provided for merit candidates"
  ];

  const whoShouldAttend = [
    "Medical, Paramedical and Life Science Graduates & Post Graduates (M.B.B.S, B.D.S, B.H.M.S, B.A.M.S, B.U.M.S, B.S.M.S, Pharmacy, Physiotherapy, Nursing, Occupational Therapy, Microbiology, Biochemistry, Biotechnology, Genetics, Biology, Bio-Medical graduates, Zoology, Botany, Bioinformatics, Endocrinology, Nutrition & Dietetics, Anatomy, Physiology, Health Education, etc.)",
    "Candidates working in HCC coding, who are willing to explore other options in their career",
    "Any graduate from life sciences would be eligible for employment in medical coding industry",
    "Non-life sciences graduates can also learn medical coding, but would need to put in more time and effort"
  ];

  const curriculum = [
    "Basics of Anatomy, Terminology, and Pathophysiology",
    "Overview of U.S. Healthcare",
    "Overview of Reimbursement Methodologies",
    "Basics of ICD-10-CM Coding",
    "Basics of CPT Coding",
    "Basics of HCPCS Coding",
    "Practical Coding Scenarios"
  ];

  const inclusions = [
    '40 Hours Expert Training',
    'Study Materials & Practice Exercises',
    'Mock Exams (AHIMA Pattern)',
    'One-on-One Mentoring',
    'Placement Assistance',
    'Certificate of Completion'
  ];

  return (
    <PageContainer>
      {/* HERO */}
      <HeroSection>
        <HeroBadge><FaBookOpen /> Foundation Program</HeroBadge>
        <HeroTitle>Basic Coding Training<span>Start Your Medical Coding Journey</span></HeroTitle>
        <HeroDesc>
          Learn the fundamentals of medical coding with industry-standard ICD-10-CM, CPT, and HCPCS coding systems.
        </HeroDesc>
        <HeroInfo>
          <div><FaClock /> Duration: <strong>40 Hours</strong></div>
          <div><FaCalendarAlt /> <strong>8-10 Weeks</strong></div>
          <div><FaTrophy /> Pass Rate: <strong>98%</strong></div>
        </HeroInfo>
      </HeroSection>

      <Container>
        {/* ROW 1: Topics + Practice */}
        <TwoCol>
          <SectionCard>
            <CardTitle><span className="card-icon"><FaBookOpen /></span>Topics Covered</CardTitle>
            <SimpleList>
              {topics.map((t, i) => <li key={i}><FaCheckCircle /> {t}</li>)}
            </SimpleList>
          </SectionCard>

          <SectionCard>
            <CardTitle><span className="card-icon"><FaStar /></span>Practice Structure</CardTitle>
            <PracticeGrid>
              {practice.map((p, i) => (
                <PracticeCard key={i}>
                  <div className="practice-icon">{p.icon}</div>
                  <h4>{p.title}</h4>
                  <p>{p.desc}</p>
                </PracticeCard>
              ))}
            </PracticeGrid>
          </SectionCard>
        </TwoCol>

        {/* BENEFITS */}
        <CardTitle><span className="card-icon"><FaTrophy /></span>Program Benefits</CardTitle>
        <TwoCol style={{marginTop:'0.5rem'}}>
          <SectionCard>
            <SimpleList>
              {benefits.map((b, i) => <li key={i}><FaCheckCircle /> {b}</li>)}
            </SimpleList>
          </SectionCard>

          <HighlightBox>
            <p style={{fontWeight:600, color:'#1a1a2e', marginBottom:'0.5rem'}}>About This Course:</p>
            <p style={{color:'#4a4a6a', fontSize:'0.9rem', lineHeight:1.6}}>
              Basic Coding Training prepares students on how to accurately code diagnoses and procedures 
              using industry-standard coding systems which include basics of ICD-10-CM, CPT, and HCPCS.
            </p>
          </HighlightBox>
        </TwoCol>

        {/* WHO SHOULD ATTEND */}
        <SectionCard style={{marginBottom:'1.5rem'}}>
          <CardTitle><span className="card-icon"><FaUsers /></span>Who Should Attend?</CardTitle>
          <NumberedList>
            {whoShouldAttend.map((item, i) => (
              <NumberedItem key={i}><span className="num">{i+1}</span><p>{item}</p></NumberedItem>
            ))}
          </NumberedList>
        </SectionCard>

        {/* CURRICULUM */}
        <SectionCard style={{marginBottom:'1.5rem'}}>
          <CardTitle><span className="card-icon"><FaBookOpen /></span>Course Curriculum</CardTitle>
          <CurrList>
            {curriculum.map((item, i) => (
              <CurrItem key={i}><FaCheckCircle /> <span>{item}</span></CurrItem>
            ))}
          </CurrList>
        </SectionCard>

        {/* CERTIFICATION & FEES */}
        <CertBlock>
          <CertHead>
            <CertHeadTitle>Certificate of Completion</CertHeadTitle>
            <CertHeadBadge>Training Certificate</CertHeadBadge>
          </CertHead>
          <CertBody>
            <CertDesc>
              A certificate of completion of training would be provided to every student who completes 
              the training course and meets the minimum scoring percentage in the final test.
            </CertDesc>

            <CertCols>
              <div>
                <CertColTitle><FaAward /> Course Inclusions</CertColTitle>
                <PlainList>
                  {inclusions.map((inc, i) => (
                    <li key={i}><FaCheckCircle />{inc}</li>
                  ))}
                </PlainList>
              </div>
              <div>
                <CertColTitle><FaListUl /> Certification Details</CertColTitle>
                <PlainList>
                  <li><FaCheckCircle />Completion Certificate provided after training</li>
                  <li><FaCheckCircle />Minimum 80% score required in final test</li>
                  <li><FaCheckCircle />Certificate validates your coding knowledge</li>
                  <li><FaCheckCircle />Adds value to your professional profile</li>
                </PlainList>
              </div>
            </CertCols>

            <FeeTable>
              <thead>
                <tr>
                  <th>Component</th>
                  <th>Description</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr className="highlight">
                  <td><strong>Course Fee</strong></td>
                  <td>To be paid to LearnThruUs Academy</td>
                  <td><span className="amt">₹17,000 + GST</span></td>
                </tr>
              </tbody>
            </FeeTable>
          </CertBody>
        </CertBlock>

        {/* CTA */}
        <CTASection>
          <CTAText>
            <div className="cta-title">Ready to Start Your Coding Journey?</div>
            <div className="cta-sub">Join our Basic Coding Training and build a strong foundation for your career.</div>
          </CTAText>
          <CTAButton to="/contact-us">
            Enroll Now <FaArrowRight />
          </CTAButton>
        </CTASection>

        <Spacer />
      </Container>
    </PageContainer>
  );
};

export default BasicCoding;